export default "__VITE_ASSET__DOTsoM4Q__"